import { Outlet } from "react-router-dom";

const InstitutionMainPage = () => {
    return <Outlet />;
}

export default InstitutionMainPage;